import { Illustration, Link, Text } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { StatusSubset } from "../types";

type TableEmptyStateProps = {
  isSearching: boolean;
  statusSubset: StatusSubset;
};
export function TableEmptyState(props: TableEmptyStateProps) {
  const { isSearching, statusSubset } = props;
  const { t } = useTranslation();

  return (
    <>
      <Illustration name={isSearching ? "no-results" : "check-success"} />
      <Text style="global/body-secondary" align="center" color="text-weak">
        {isSearching && t("No results found.")}
        {!isSearching && (
          <>
            {statusSubset === "active" && t("You have no active cases.")}
            {statusSubset === "review" && t("You have no cases to review.")}
            {statusSubset === "done" && t("You have no cases at this stage.")}
            {statusSubset === "legacy" && t("You have no legacy cases.")}
          </>
        )}
      </Text>
      {!isSearching && statusSubset === "active" && (
        <Link
          testID="start-new-order-link"
          target="_blank"
          href="/order"
          textStyle="global/body-secondary"
          textColor="text-weak"
        >
          {t("Start a new order")}
        </Link>
      )}
    </>
  );
}
